import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './hermes.css'
import { DemoStoreProvider } from './store'
import './styles.css'
import './styles/venture-studio.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <DemoStoreProvider>
        <App />
      </DemoStoreProvider>
    </BrowserRouter>
  </StrictMode>,
)
